import { render, staticRenderFns } from "./tabViewNew.vue?vue&type=template&id=028dd62c&scoped=true"
import script from "./tabViewNew.vue?vue&type=script&lang=js"
export * from "./tabViewNew.vue?vue&type=script&lang=js"
import style0 from "./tabViewNew.vue?vue&type=style&index=0&id=028dd62c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "028dd62c",
  null
  
)

export default component.exports